import $ from 'jquery';

$(document).ready(() => {
   /* function accordion() { Disparait avec la v3 : 20/12/2021
        let toogle = $('.accordion .toggle');
        toogle.click(function(e) {
            e.preventDefault();
            toogle.removeClass('active')

            var $this = $(this);

            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $this.toggleClass('active')
                $this.parent().parent().find('li .inner').removeClass('show');
                $this.parent().parent().find('li .inner').slideUp(350);
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });
    }
    accordion()

    window.addEventListener('load', function () {
        let anchor = 'scroll-' + window.location.toString().split('#')[1];
        let speed =1500; // Durée de l'animation (en ms)
        let target = document.getElementById(anchor);
        if (target) {
            $('html, body').animate( { scrollTop: $(target).offset().top -70 }, speed ); // Go
            setTimeout(function () {
                $(target).click();
            }, speed);
        }
    });*/
})

